export default __webpack_public_path__ + "static/media/premium1.3de79df2.webp";